'use strict';

angular.module('programme')

.directive('keyMoments', function ($window)
{
    function link ($scope)
    {
        $scope.captionOpen = false;

        $scope.toggleCaption = function() {
            $scope.captionOpen = !$scope.captionOpen;
        }

        // Set component height and listener to adjust height on resize
        var init = function ()
        {
            $scope.componentHeight = $window.innerHeight;

            var onResize = function () {
                $scope.componentHeight = $window.innerHeight;

                $scope.$apply();
            };

            angular.element($window).bind('resize', onResize);

            $scope.$on('$destroy', function() {
                angular.element($window).off('resize', onResize);
            });
        };

        init();
    }

    return {
        restrict: 'A',
        templateUrl: 'modules/programme/editor-components/key-moments/keyMoments.html',
        link: link,
        controller: 'KeyMomentsCtrl',
        controllerAs: '$ctrl'
    };
})

.controller('KeyMomentsCtrl', function ($scope)
{
    this.defaultSlide = {
        caption: 'Players from West Germany and Colombia walk out at the San Siro for their group game at the 1990 World Cup',
        image: [
            {
                type: 'image',
                data: {
                    setAspectRatio: true
                }
            }
        ],
        club: 'Club',
        clubFontSize: 'Default',
        score: 'Team One 1 - 2 Team Two (MD2)',
        description: 'Description of this image'
    };

    $scope.data.timerInterval = $scope.data.timerInterval || 0;
    $scope.data.componentTitle = $scope.data.componentTitle || 'Key moments';
    $scope.data.list = $scope.data.list || [];

    $scope.images = {};
    $scope.activeSlide = 0;
    $scope.selected = null;
    $scope.slidesTotal = $scope.data.list.length;

    $scope.setSelectedSlide = function(index)
    {
        $scope.selected = $scope.data.list[index];
    };

    $scope.getActiveSlide = function()
    {
        return $scope.data.list.filter(function(slide){
            return slide.active;
        })[0];
    };

    this.$onInit = function ()
    {
        if (!$scope.data.list.length) {
            this.addSlide(true);
        }
    };

    this.addSlide = function ()
    {
        var s = angular.copy(this.defaultSlide);
        $scope.data.list.push(s);

        $scope.slidesTotal = $scope.data.list.length;

        if ($scope.selected === null) {
            $scope.selected = $scope.data.list[0];
        }
    };

    this.changeSlideClubFontSize = function (clubFontSize) {
        $scope.data.list[$scope.activeSlide].clubFontSize = clubFontSize;
    };

    this.selectSlide = function (slide)
    {
        this.selected = slide;
    };

    $scope.destroySlide = function (slide)
    {
        var index = $scope.data.list.indexOf(slide);
        if (index === -1) {
            return;
        }

        $scope.data.list.splice(index, 1);
    };

    $scope.$on('component:focus', function ($event)
    {
        if ($event.targetScope.item) {
            this.selectSlide($event.targetScope.item);
        }
    }.bind(this));

    this.$onInit();
});
